class Future {
    static States = Object.freeze({
        PENDING: Symbol('pending'),
        RESOLVED: Symbol('resolved'),
        REJECTED: Symbol('rejected'),
    });
    #_promise;
    #_resolveFn;
    #_rejectFn;
    #_futureState = Future.States.PENDING;
    constructor() {
        this.#_promise = new Promise((resolve, reject) => {
            this.#_resolveFn = resolve;
            this.#_rejectFn = reject;
        });
    }
    get promise() {
        return this.#_promise;
    }
    /**
     * This exists because of a strange Native promise behavior... Let me explain!
     * When you use finally in a rejection scenario...
     * it under the covers creates a new rejection that is the same as original rejection...
     * this causes node to trigger an `unhandledRejection`
     * 
     * So what we have done is expose this method that gobbles that second rejection.
     */
    finally(callback, thisContext) {
        this.#_promise
            .finally(async () => {
                await callback.call(thisContext);
            })
            .catch(e => {
                //gobble gobble
            });
    }
    resolve(value) {
        if (this.isPending()) {
            this.#_futureState = Future.States.RESOLVED;
            this.#_resolveFn(value);
        }
        else {
            throw new Error(`Cannot resolve a previously ${this.#_futureState.description} future.`);
        }
    }
    reject(error) {
        if (this.isPending()) {
            this.#_futureState = Future.States.REJECTED;
            this.#_rejectFn(error);
        }
        else {
            throw new Error(`Cannot reject a previously ${this.#_futureState.description} future.`);
        }
    }
    isPending() {
        if (this.#_futureState === Future.States.PENDING) {
            return true;
        }
        else {
            return false;
        }
    }
    isCompleted() {
        if (this.isResolved() || this.isRejected()) {
            return true;
        }
        else {
            return false;
        }
    }
    isResolved() {
        if (this.#_futureState === Future.States.RESOLVED) {
            return true;
        }
        else {
            return false;
        }
    }
    isRejected() {
        if (this.#_futureState === Future.States.REJECTED) {
            return true;
        }
        else {
            return false;
        }
    }
}
export { Future };
export default Future;